// Template Generated by DataExtraction.py at 1716507313

import EnglishMat1 from "../../Forms/KYC2/English_Mat-1.png";
import EnglishMat1Labels from "../../Labels/KYC2/English_Mat-1.json";
import FrenchMat1 from "../../Forms/KYC2/French_Mat-1.png";
import FrenchMat1Labels from "../../Labels/KYC2/French_Mat-1.json";
import {
    drawTextOnLabel,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    signatureLabel,
    signatureTab,
    formatDayFromDate,
    formatMonthFromDate,
    formatYearFromDate,
    drawText as drawTextAtPos,
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import {
    calculateAgeOfYoungestBeneficiary,
    calculateTimeHorizon,
    calculateTotalInvestmentAssets,
    calculateTotalOtherAssets,
    calculateApproximateNetWorth,
    monthlyAvailableSavingsForRespContributions,

    isDisposableIncomeExceeded,
    isEightyYearRuleExceeded,
    isKnowYourClientFormComplete,
} from "../../../Utils/KYCUtils";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchMat1Labels : EnglishMat1Labels;
    const formImage = isFrench ? FrenchMat1 : EnglishMat1;

    function fillCheckbox(value, label) {
        drawTextOnLabel(doc, value ? t("Yes") : t("No"), label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    // add image
    doc.addImage(
        formImage,
        standardFormFormat,
        labels["image"]["x"],
        labels["image"]["y"],
        labels["image"]["width"],
        labels["image"]["height"],
        null,
        standardFormCompression,
    );

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;
    const application = data.application;
    const beneficiary = data.beneficiary;

    const d1 = data.dependant;
    const d2 = data.dependant2;
    const d3 = data.dependant3;
    const d4 = data.dependant4;

    const subscriber2Include = common.subscriber2Include;

    const s1Name =
        subscriber.firstName +
        (subscriber.lastName ? " " + subscriber.lastName : "");
    const s2Name =
        jointSubscriber.firstName +
        (jointSubscriber.lastName ? " " + jointSubscriber.lastName : "");

    const planTypeID = plan.planTypeID;
    const planTypeMappings = {
        "-1": "",
        0: "Group",
        1: "Self-Initiated",
        2: "Achievers",
    };
    const planType = planTypeMappings[planTypeID];

    const dateFormat = "MM/DD/yyyy";

    // Application details
    drawText(application.tcpName, "tcpName");
    drawText(application.tcpRelationship, "tcpRelationship");
    drawText(application.tcpPhone, "tcpPhone");
    drawText(application.tcpEmail, "tcpEmail");

    drawText(s1Name, "s1Name");
    drawText(t(planType), "planType");
    drawText(subscriber.occupation, "s1Occupation");
    drawText(subscriber.employer, "s1Employer");

    drawText(formatMonthFromDate(subscriber.birthdate), "s1DobMonth");
    drawText(formatDayFromDate(subscriber.birthdate), "s1DobDay");
    drawText(formatYearFromDate(subscriber.birthdate), "s1DobYear");

    drawText(t(subscriber.investmentExperience), "s1InvestmentExperience");
    drawText(subscriber.investmentTypes, "s1InvestmentTypes");
    drawText(t(kyc.riskTolerance), "riskTolerance");

    // Affordability Checkbox
    if (planTypeID === 0 || planTypeID === 2) {
        drawText(t("Yes"), "affordabilityYesNo");
    } else if (planTypeID === 1) {
        drawText(t("No"), "affordabilityYesNo");
    }

    if (subscriber2Include) {
        drawText(s2Name, "s2Name");
        drawText(jointSubscriber.occupation, "s2Occupation");
        drawText(jointSubscriber.employer, "s2Employer");
        drawText(formatMonthFromDate(jointSubscriber.birthdate), "s2DobMonth");
        drawText(formatDayFromDate(jointSubscriber.birthdate), "s2DobDay");
        drawText(formatYearFromDate(jointSubscriber.birthdate), "s2DobYear");
        drawText(
            t(jointSubscriber.investmentExperience),
            "s2InvestmentExperience",
        );
        drawText(jointSubscriber.investmentTypes, "s2InvestmentTypes");
    }

    // Financial / Assets / Liabilities
    drawText(
        displayCurrency(kyc.cashAndLiquid, i18n.language),
        "cashAndLiquid",
    );
    drawText(displayCurrency(kyc.securities, i18n.language), "securities");
    drawText(
        displayCurrency(kyc.registeredAccountsRESPAndTFSA, i18n.language),
        "registeredAccountsRESPAndTFSA",
    );
    drawText(
        displayCurrency(kyc.RegisteredAccountsRESPs, i18n.language),
        "RegisteredAccountsRESPs",
    );
    drawText(
        displayCurrency(kyc.investmentAssetsOther, i18n.language),
        "investmentAssetsOther",
    );
    drawText(
        displayCurrency(calculateTotalInvestmentAssets(kyc), i18n.language),
        "totalInvestmentAssets",
    );

    drawText(
        displayCurrency(kyc.principalResidenceEquity, i18n.language),
        "principalResidenceEquity",
    );
    drawText(
        displayCurrency(kyc.otherRealEstateEquity, i18n.language),
        "otherRealEstateEquity",
    );
    drawText(
        displayCurrency(kyc.otherAssetsVehicles, i18n.language),
        "otherAssetsVehicles",
    );
    drawText(
        displayCurrency(kyc.collectablesArtValuables, i18n.language),
        "collectablesArtValuables",
    );
    drawText(displayCurrency(kyc.otherAssets, i18n.language), "otherAssets");
    drawText(
        displayCurrency(calculateTotalOtherAssets(kyc), i18n.language),
        "totalOtherAssets",
    );

    drawText(displayCurrency(kyc.liabilities, i18n.language), "liabilities");
    drawText(
        displayCurrency(
            kyc.netWorth || calculateApproximateNetWorth(kyc),
            i18n.language,
        ),
        "netWorth",
    );

    // Maternity Specific Fields
    drawText(
        kyc.returnToWorkDate ? moment(kyc.returnToWorkDate).format("MM") : "",
        "returnDateMonth",
    );
    drawText(
        kyc.returnToWorkDate ? moment(kyc.returnToWorkDate).format("YYYY") : "",
        "returnDateYear",
    );
    drawText(kyc.maternityLeave ? t("Yes") : t("No"), "matLeaveYesNo");

    // Savings info
    drawText(
        displayCurrency(
            kyc.availableSavingsForRespContributions,
            i18n.language,
        ),
        "availableSavingsForRESPContributions",
    );
    drawText(kyc.locationAndTypeOfSavings, "locationAndTypeOfSavings");
    // Savings info
    drawText(
        displayCurrency(
            monthlyAvailableSavingsForRespContributions(kyc),
            i18n.language,
        ),
        "availableMonthlyContributionFromSavings",
    );

    // General KYC Fields
    drawText(kyc.objective, "objective");
    drawText(
        common.borrowingToInvest ? t("Yes") : t("No"),
        "leveraging",
        common.borrowingToInvest ? { r: 255, g: 0, b: 0, a: 1 } : null,
    );
    drawText(
        kyc.anticipateKeepContributions ? t("Yes") : t("No"),
        "anticipateKeepContributions",
    );
    drawText(kyc.existingSubscriber ? t("Yes") : t("No"), "existingSubscriber");
    drawText(
        kyc.anticipateAbleToKeepContributions ? t("Yes") : t("No"),
        "anticipateAbleToKeepContributions",
    );
    drawText(kyc.afterMaternityLeaveEnds, "afterMatParentsWill");
    drawText(kyc.pepYN ? t("Yes") : t("No"), "PEPOrHIO");

    // Dependants
    if (kyc.numberOfDependants >= 1) {
        drawText(d1.yearsOfEducationalSupport, "d1Edu");
        let d1Name = d1.name;
        let d1Birthdate = moment(d1.birthdate).format(dateFormat);

        if (kyc.beneficiaryIsADependant) {
            d1Name =
                beneficiary.firstName +
                (beneficiary.lastName ? " " + beneficiary.lastName : "");
            d1Birthdate = moment(beneficiary.birthdate).format(dateFormat);
        }

        drawText(d1Name, "d1Name");
        drawText(d1Birthdate, "d1Birthdate");
    }

    if (kyc.numberOfDependants >= 2) {
        drawText(moment(d2.birthdate).format(dateFormat), "d2Birthdate");
        drawText(d2.yearsOfEducationalSupport, "d2Edu");
        drawText(d2.name, "d2Name");
    }

    if (kyc.numberOfDependants >= 3) {
        drawText(moment(d3.birthdate).format(dateFormat), "d3Birthdate");
        drawText(d3.yearsOfEducationalSupport, "d3Edu");
        drawText(d3.name, "d3Name");
    }

    if (kyc.numberOfDependants >= 4) {
        drawText(moment(d4.birthdate).format(dateFormat), "d4Birthdate");
        drawText(d4.yearsOfEducationalSupport, "d4Edu");
        drawText(d4.name, "d4Name");
    }

    drawText(
        `${calculateAgeOfYoungestBeneficiary(beneficiary, kyc)}`,
        "ageOfYoungestBene",
    );
    drawText(calculateTimeHorizon(beneficiary, kyc), "timeHorizon");


    if (
        !isKnowYourClientFormComplete(subscriber, jointSubscriber, kyc, common)
    ) {
        drawText(t("Form Incomplete"), "formIncomplete", {
            r: 255,
            g: 0,
            b: 0,
            a: 255,
        });
    }
    drawText(isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? t("Disposable Income Exceeded") : "", "diExceeded", isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
    drawText(isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? t("Note deposit schedule and subscriber's 80th birthday") : "", "eightyYearRule", isEightyYearRuleExceeded(subscriber, jointSubscriber, kyc, common) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
};

//Returns the signature definitions for the document
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    let signers = [];
    return signers;
};

export default {
    generate,
    signatureDefinitions,
};
